import { FaAngleLeft } from 'react-icons/fa';
import { Header, InformationText } from '../texts/Texts';
import styles from './PageHeader.module.scss';
import { DetailedHTMLProps, HTMLAttributes } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getMenus } from 'common/layouts/sidebar/components/Menus';

type Props = {
    title: string;
    subTitle?: string;
    informationText: string;
    showGoBack?: boolean;
    addSidebarSpacing?: boolean;
    onGoBack?: () => void;
} & DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

const PageHeader = ({ children, title, subTitle, informationText, showGoBack = true, addSidebarSpacing = false, onGoBack, ...props }: Props) => {
    const navigate = useNavigate();
    const location = useLocation();

    // Resolve the parent navigation menu (e.g. '/home/library') for the current
    // section so the back button goes up the hierarchy instead of through browser
    // history. Falls back to the home screen when no matching menu exists.
    const getParentMenuUrl = () => {
        const firstSegment = location.pathname.split('/').filter(Boolean)[0];
        if (firstSegment) {
            const candidate = `/home/${firstSegment}`;
            if (getMenus().some(menu => menu.url === candidate)) {
                return candidate;
            }
        }
        return '/';
    }

    const goBack = () => {
        if (onGoBack) {
            onGoBack();
        } else {
            navigate(getParentMenuUrl());
        }
    }

    return (
        <div {...props} className={`${styles.container} ${props.className ?? ''}`}>
            {showGoBack && <div className={styles.iconContainer} onClick={goBack}>
                <FaAngleLeft />
            </div>}
            <div className={styles.titles}>
                <InformationText small>{informationText}</InformationText>
                <div className={styles.titleRow}>
                    <Header className={styles.header} title={title}>{title}</Header>
                    {Boolean(subTitle) && <InformationText medium className={styles.subTitle} title={subTitle}>{subTitle}</InformationText>}
                </div>
            </div>
            <div className={`${styles.actions} ${addSidebarSpacing ? styles.sidebarSpacing : ''}`}>
                {children}
            </div>
        </div>
    );
};

export default PageHeader;
